
import detail from './detail'
import edit from './edit'

export default {
    list: detail,
    edit: edit,
    name: "profiles",
    key: "p_profiles",
}